/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

export enum PermissionType {
    NONE = 'NONE',
    READ_ONLY = 'READ_ONLY',
    READ_WRITE = 'READ_WRITE',
}

interface BaseClientData {
    id: number;
    name: string;
    level: number;
    statusId: string;
}

export interface ClientData extends BaseClientData {
    address?: {
        id: number;
        stdAddress?: string;
        rawAddress?: string;
        stdCity: string;
        stdCountry: string;
        stdDeliveryLine: string;
        stdPostalCode: string;
        stdRegion: string;
    };
    accountPermissions: {
        id: number;
        permissionTypeId: PermissionType;
    }[];
}

export interface ClientsRow extends BaseClientData {
    virtualId: string;
    stdAddress?: string;
    addressId?: number;
    readOnly: boolean;
}
